export interface Share {
    id: number;
    share_type: 'user' | 'club' | 'team' | 'club_role' | 'team_role';
    share_target_id: number;
    share_role: 'manager' | 'coach' | 'athlete' | null;
    permission: 'read';
    target_name: string;
}

export interface Folder {
    id: number;
    name: string;
    description: string;
    parent_id: number | null;
    is_shared: number;
    is_owner: boolean;
    can_write: boolean;
    shares: Share[];
    item_count: number;        // Total items directos (subfolder_count + document_count)
    subfolder_count: number;   // Número de subcarpetas directas
    document_count: number;    // Número de documentos directos
    total_size: number;        // Tamaño total en bytes (recursivo)
    created_by: number;
    created_by_name?: string;  // Nombre del creador/propietario
    created_at: string;
    changed_by: number;
    changed_at: string;
}

export const emptyFolder: Folder = {
    id: 0,
    name: '',
    description: '',
    parent_id: null,
    is_shared: 0,
    is_owner: false,
    can_write: false,
    shares: [],
    item_count: 0,
    subfolder_count: 0,
    document_count: 0,
    total_size: 0,
    created_by: 0,
    created_at: '',
    changed_by: 0,
    changed_at: ''
}

export const emptyShare: Share = {
    id: 0,
    share_type: 'user',
    share_target_id: 0,
    share_role: null,
    permission: 'read',
    target_name: ''
}
